var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-img',{attrs:{"height":"257px","src":_vm.macrotrend.image}}),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.macrotrend.description)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }